module.exports = __webpack_public_path__ + "static/media/icono_home_scope.c1fe6648.png";